const defaultTheme = {
    logo: '/Epik-Logo-Color.png',
    colorToolbar: '#17a2b8',
    colorPrimary: '#17a2b8',
    colorSecondary: '#17a2b8',
};

export default (state = defaultTheme, action) => {
    switch (action.type) {
        default:
            return state;
    }
}